import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Participation',
    lead: "L'entonnoir d'engagement : d'invité à structurellement actif, plus les taux d'engagement quotidiens.",
    noScope: 'Sélectionnez une entreprise pour voir ses chiffres de participation.',
    noDepartments: "Aucun département ici n'a de statistiques que vous pouvez voir.",
    disclaimer:
      'Tous les chiffres sont des indicateurs de bien-être indicatifs et ne constituent pas un diagnostic médical. Les tendances ne sont affichées que pour un nombre suffisant de participants (protection de la vie privée dès la conception).',
  },
  filters: {
    department: {
      label: 'Département',
    },
    location: {
      label: 'Site',
      all: 'Tous les sites',
    },
  },
  funnel: {
    title: "Entonnoir d'engagement",
    pctOfPrevious: "{{pct}}% de l'étape précédente",
    steps: {
      invited: 'Invités',
      activated: 'Activés',
      active_7d: 'Actifs (7j)',
      active_30d: 'Actifs (30j)',
      structurally_active: 'Structurellement actifs',
      needs_reactivation: 'À réactiver',
    },
  },
  rates: {
    title: "Taux d'engagement",
    keys: {
      daily_sync_pct: 'Synchronisation quotidienne',
      ai_coach_use_pct: 'Utilisation du coach IA',
      challenge_participation_pct: 'Participation aux challenges',
      notification_open_pct: 'Ouvertures de notifications',
      break_adoption_pct: 'Adoption des pauses',
      focus_rhythm_pct: 'Rythme de concentration',
    },
  },
  breakdown: {
    department: 'Par département',
    location: 'Par site',
    pilotGroup: 'Par groupe pilote',
    empty: 'Pas encore de données à ventiler.',
    pilotGroupEmpty: 'Aucun pilote ne couvre encore ce département.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Protégé',
      message:
        'Pas assez de participants ({{invited}}) pour un affichage respectueux de la vie privée — au moins {{min}} requis.',
    },
    columns: {
      name: 'Nom',
      invited: 'Invités',
      activated: 'Activés',
      active30d: 'Actifs (30j)',
    },
  },
  status: {
    noData: '—',
  },
};
